import masterData from "./master-data";

export const ROOM_TYPE_OPTIONS = [
  {
    id: 1,
    value: "unfurnished",
    title: "Unfurnished",
  },
  {
    id: 2,
    value: "furnished",
    title: "Furnished",
  },
];

export const AVAILABILITY_OPTIONS = [
  {
    id: 1,
    value: "available",
    title: "Available",
  },
  {
    id: 2,
    value: "reserved",
    title: "Reserved",
  },
  {
    id: 3,
    value: "sold",
    title: "Sold",
  },
];

export const MEDIA_TYPE_OPTION = [
  {
    value: masterData.MEDIA_TYPE_ENUM["360_PANO_TOUR"],
    title: "360 Pano tour",
  },
  {
    value: masterData.MEDIA_TYPE_ENUM.FLOORPLAN,
    title: "Floorplan",
  },
  {
    value: masterData.MEDIA_TYPE_ENUM.IMAGE,
    title: "Image",
  },
  {
    value: masterData.MEDIA_TYPE_ENUM.INTERIOR_ID,
    title: "Interior id",
  },
  {
    value: masterData.MEDIA_TYPE_ENUM.VIDEO,
    title: "Video",
  },
];

export const ASPECT_OPTION = [
  {
    id: 1,
    name: "Sea view",
    value: "sea_view",
    description: "Face the sea",
  },
  {
    id: 2,
    name: "City view",
    value: "city_view",
    description: "Face the city",
  },
];

export const PROPERTY_TYPE_OPTION = [
  {
    value: masterData.PROPERTY_TYPE_ENUM.APARTMENT,
    title: "Apartment",
  },
  {
    value: masterData.PROPERTY_TYPE_ENUM.HOUSE,
    title: "House",
  },
  {
    value: masterData.PROPERTY_TYPE_ENUM.LAND,
    title: "Land",
  },
  {
    value: masterData.PROPERTY_TYPE_ENUM.OFFICE,
    title: "Office",
  },
  {
    value: masterData.PROPERTY_TYPE_ENUM.TOWNHOUSE,
    title: "Townhouse",
  },
  {
    value: masterData.PROPERTY_TYPE_ENUM.UNIT,
    title: "Unit",
  },
  {
    value: masterData.PROPERTY_TYPE_ENUM.VILLA,
    title: "Villa",
  },
];

export const UNIT_OPTION = [
  {
    value: masterData.UNIT_ENUM.ACRE,
    title: "Acre",
  },
  {
    value: masterData.UNIT_ENUM.HECTARE,
    title: "Hectare",
  },
  {
    value: masterData.UNIT_ENUM.SQUARE,
    title: "Square",
  },
  {
    value: masterData.UNIT_ENUM.SQUARE_METER,
    title: "Square meter",
  },
];

export const BEDROOM_OPTION = [
  {
    title: "2",
    id: 2,
    value: 2,
  },
  {
    title: "3",
    id: 3,
    value: 3,
  },
  {
    title: "4",
    id: 4,
    value: 4,
  },
  {
    title: "5",
    id: 5,
    value: 5,
  },
  {
    title: "6",
    id: 6,
    value: 6,
  },
];

export const PARKING_STALLS = [
  {
    title: "2",
    value: 2,
  },
  {
    title: "3",
    value: 3,
  },
];

export const PAGES = {
  NONE: "NONE",
  INTRODUCE_PAGE: "INTRODUCE_PAGE",
  AMENITY_PAGE: "AMENITY_PAGE",
  UNIT_EXPLORER_PAGE: "UNIT_EXPLORER_PAGE",
  GALLERY_PAGE: "GALLERY_PAGE",
  IMMERSE_PAGE: "IMMERSE_PAGE",
  TEAM_PAGE: "TEAM_PAGE",
  LOCATION_PAGE: "LOCATION_PAGE",
  ONBOARD_PAGE: "ONBOARD_PAGE",
  EXCUTIVE_SUMMARY_PAGE: "EXCUTIVE_SUMMARY_PAGE",
  SEARCH_PAGE: "SEARCH_PAGE",
  LANDING_PAGE: "LANDING_PAGE",
  EXPLORE_PRECINCT_PAGE: "EXPLORE_PRECINCT_PAGE",
  EXPLORE_DISTRICT_PAGE: "EXPLORE_DISTRICT_PAGE",
  EXPLORE_CITY_PAGE: "EXPLORE_CITY_PAGE",
  EXPLORE_BUILDING_PAGE: "EXPLORE_BUILDING_PAGE",
  PRECINCT_SUMMANRY_PAGE: "PRECINCT_SUMMANRY_PAGE",
  ENVIRONMENT_PAGE: "ENVIRONMENT_PAGE",
  END_GUIDE_TENANT_SESSION_PAGE: "END_GUIDE_TENANT_SESSION_PAGE",
  ABOUT_PAGE: "ABOUT_PAGE",
  LIFE_STYLE_PAGE: "LIFE_STYLE_PAGE",
  AMENITIES_PAGE: "AMENITIES_PAGE",
  VIEWS_PAGE: "VIEWS_PAGE",
  SERVICES_PAGE: "SERVICES_PAGE",
  GALLERY_LANDING_PAGE: "GALLERY_LANDING_PAGE",
  EXPERIENCE_PAGE: "EXPERIENCE_PAGE",
  STORY_PAGE: "STORY_PAGE",
  RESIDENCES_PAGE: "RESIDENCES_PAGE",
  VIEW_PAGE: "VIEW_PAGE",
  VIEW_DETAIL_PAGE: "VIEW_DETAIL_PAGE",
  VISION_PAGE: "VISION_PAGE",
  SESSION_PAGE: "SESSION_PAGE",
};

export const TOP_NAV_TABS = [
  PAGES.VISION_PAGE,
  PAGES.RESIDENCES_PAGE,
  PAGES.AMENITIES_PAGE,
  PAGES.EXPERIENCE_PAGE,
  PAGES.VIEW_PAGE,
  PAGES.LOCATION_PAGE,
  PAGES.TEAM_PAGE,
  PAGES.GALLERY_LANDING_PAGE,
];

export const LAYERS = {
  NONE: 0,
  HOTPOT: 1,
  UNITS: 2,
  FEATURE_HOUSE: 3,
  D_HOTSPOT: 4,
  EXPLORE_DISTRICT_HOTSPOT: 5,
  PINS_DO: 6,
  DO_BUILDING: 7,
  LANDING: 8,
  EXPLORE_CITY_ONLY: 9,

  BUILDING_23: 13,
  BUILDING_25: 15,
  BUILDING_27: 17,
  BUILDING_29: 19,
  BUILDING_31: 21,

  DISABLE: 31,
};

export const OBJECT_TYPES = {
  NONE: "none",
  DO: "do",
  FD: "fd",
  UNIT: "unit",
  AREA: "area",
  AMENITY: "amenity",
};
export const HOTSPOT_TYPES = {
  GALLERY: "gallery",
  PANO_TOUR: "360_pano_tour",
  URL: "url",
  VIDEO: "video",
  EXCUTIVE_SUMMARY: "excutive_summary",
  AMENITY: "amenity",
  UNIT_EXPLORE: "unit_explore",
  MODAL: "modal",
  AMENITY_ITEM: "amenity_item",
  EXPLORE_DISTRICT: "explore_district",
  EXPLORE_DISTRICT_DETAIL: "explore_district_detail",
  FUTURE_ITEM: "future_item",
  EXPLORE_DISTRICT_PAGE: "explore_district_page",
  LOCATION_PAGE: "location_page",
  AMENITY_PAGE: "amenity_page",
  EXPLORE_BUILDING: "explore_building",
  EXPLORE_CITY: "explore_city",
  EXPLORE_AVAILABILITY: "explore_availability",
};

export default {
  MEDIA_TYPE_OPTION,
  PROPERTY_TYPE_OPTION,
  UNIT_OPTION,
  PARKING_STALLS,
  PAGES,
  LAYERS,
  OBJECT_TYPES,
  HOTSPOT_TYPES,
  AVAILABILITY_OPTIONS,
};

export const GROSS_RENT_OPTION = [
  {
    id: 1,
    text: "$50 - 100 PSM",
    min: 50,
    max: 100,
  },
  {
    id: 2,
    text: "$100 - 200 PSM",
    min: 100,
    max: 200,
  },
  {
    id: 3,
    text: "$200+ PSM",
    min: 200,
  },
];

export const CENTRE_OPTION = [
  {
    text: "Existing Centre",
    value: "Existing Centre",
  },
  {
    text: "Cinema Building",
    value: "Cinema Building",
  },
  {
    text: "Fresh Food",
    value: "Fresh Food",
  },
];

export const LEVEL_OPTION = [
  {
    text: "Ground",
    value: "GROUND",
  },
  {
    text: "Level 1",
    value: "LEVEL ONE",
  },
];

export const AREA_OPTION = [
  {
    id: 1,
    min: 10,
    max: 50,
    text: "10 - 50 sqm",
  },
  {
    id: 2,
    min: 50,
    max: 200,
    text: "50 - 200 sqm",
  },
  {
    id: 3,
    min: 200,
    max: 500,
    text: "200 - 500 sqm",
  },
  {
    id: 4,
    min: 500,
    text: "500+ sqm",
  },
];

export const PRECINCT_OPTION = [
  {
    text: "Entertainment and F&B",
    value: "Entertainment and F&B",
  },
  {
    text: "General Retail",
    value: "General Retail",
  },
  {
    text: "Health & Wellbeing",
    value: "Health & Wellbeing",
  },
  {
    text: "Lifestyle & Tourism",
    value: "Lifestyle & Tourism",
  },
  {
    text: "Commercial Office",
    value: "Commercial Office",
  },
  {
    text: "Fresh Food and Daily Needs",
    value: "Fresh Food and Daily Needs",
  },
];

export const SUB_TAB_GALLERY = {
  IMAGES: { key: "IMAGES", text: "Images" },
  FILMS: { key: "FILMS", text: "Films" },
  VIRTUAL_TOURS: { key: "VIRTUAL TOURS", text: "Virtual Tours" },
  // FLOOR_PLANS: { key: "FLOORPLANS", text: "Floorplans" },
};
export const TAB_GALLERY = {
  ORLA: "ORLA",
  ORLA_INFINITY: "ORLA INFINITY",
};
export const GALLERY_TYPE = {
  VIDEO: "video",
  IMAGE: "image",
  VIRTUAL_TOUR: "virtual_tour",
  MEDIA_IMAGES: "media_images",
};

export const WEBSOCKET_CHANNEL = {
  SHARE_UI_ACTION: "share_screen_ui_action",
  SHARE_CAMERA_ACTION: "share_screen",
  SHARE_3D_BUILDING_ACTION: "share_3d_building_action",
  SHARE_PANORAMA_ACTION: "share_panorama_action",
  LIGHT_UP: "light_up",
  LIGHT_CONNECT: "lightswarm_connected",
  LIGHT_DISCONNECT: "lightswarm_disconnected",
  LIGHT_ERROR: "turnLightErrors",
  LIGHT_TCP_CONNECTED: "light_tcp_connected",
  LIGHT_FORCE_NEW_SESSION: "light_force_new_session",
  LIGHT_SESSION_CHANGED: "light_session_changed",
  LIGHT_TCP_CHECK_STATUS: "light_tcp_check_status",
  LIGHT_TCP_CHECK_STATUS_ACK: "light_tcp_check_status_ack",
  LIGHT_CHECK_ACTIVE_SESSION: "light_check_active_session",
  LIGHT_CHECK_ACTIVE_SESSION_ACK: "light_check_active_session_ack",
};

export const ACTION_NAME = {
  CLICK_UNIT_EXPLORE_MENU: "CLICK_UNIT_EXPLORE_MENU",
  CLICK_UNIT_FILTER: "CLICK_UNIT_FILTER",
  CLICK_LOCATION_MENU: "CLICK_LOCATION_MENU",
  CLICK_AMENITIES_MENU: "CLICK_AMENITIES_MENU",
  CLICK_CUBE_MENU: "CLICK_CUBE_MENU",
  CLICK_VIEW_MENU: "CLICK_VIEW_MENU",
  CLICK_VISION_MENU: "CLICK_VISION_MENU",
  CLICK_RESIDENCES_MENU: "CLICK_RESIDENCES_MENU",
  CLICK_EXPERIENCE_MENU: "CLICK_EXPERIENCE_MENU",
  CLICK_GALLERY_MENU: "CLICK_GALLERY_MENU",
  CLICK_TEAM_MENU: "CLICK_TEAM_MENU",
  CLICK_IMMERSER_MENU: "CLICK_IMMERSER_MENU",
  CLICK_SEARCH_MENU: "CLICK_SEARCH_MENU",
  CLICK_START_DISCOVER: "CLICK_START_DISCOVER",
  CLICK_UNIT_FILTER: "CLICK_UNIT_FILTER",
  CLICK_UNIT: "CLICK_UNIT",
  CLICK_HOTSPOT: "CLICK_HOTSPOT",
  CLICK_AMENITY_ITEM: "CLICK_AMENITY_ITEM",
  CLICK_CLOSE_MODAL: "CLICK_CLOSE_MODAL",
  CLICK_MODAL_BUTTON: "CLICK_MODAL_BUTTON",
  CHANGE_MODAL_CONTENT: "CHANGE_MODAL_CONTENT",
  SHOW_UNIT_GALLERY: "SHOW_UNIT_GALLERY",
  CLOSE_UNIT_GALLERY: "CLOSE_UNIT_GALLERY",
  SHOW_UNIT_FLOORPLAN: "SHOW_UNIT_FLOORPLAN",
  CLOSE_UNIT_FLOORPLAN: "CLOSE_UNIT_FLOORPLAN",
  CLICK_EYE_ICON: "CLICK_EYE_ICON",
  CLICK_NEXT_GALLERY: "CLICK_NEXT_GALLERY",
  CLICK_PREV_GALLERY: "CLICK_PREV_GALLERY",
  CHANGE_SLIDE_GALLERY: "CHANGE_SLIDE_GALLERY",
  CLICK_FLOORPLAN_SLIDE_BTN: "CLICK_FLOORPLAN_SLIDE_BTN",
  ZOOM_IN_FLOORPLAN: "ZOOM_IN_FLOORPLAN",
  ZOOM_OUT_FLOORPLAN: "ZOOM_OUT_FLOORPLAN",
  NEXT_FLOORPLAN: "NEXT_FLOORPLAN",
  PREV_FLOORPLAN: "PREV_FLOORPLAN",
  CLICK_SEARCH_UNIT: "CLICK_SEARCH_UNIT",
  CLICK_SEARCH_AMENITY: "CLICK_SEARCH_AMENITY",
  CLICK_SEARCH_POI: "CLICK_SEARCH_POI",
  CHANGE_POI_MODAL: "CHANGE_POI_MODAL",
  CLICK_POI_GROUP: "CLICK_POI_GROUP",
  CLOSE_POI_MODAL: "CLOSE_POI_MODAL",
  CHANGE_POI_GROUP: "CHANGE_POI_GROUP",
  CHANGE_ACTIVE_POI: "CHANGE_ACTIVE_POI",
  CHANGE_ACTIVE_TYPE: "CHANGE_ACTIVE_TYPE",
  WINDOW_SIZE: "WINDOW_SIZE",
  CHANGE_PANORAMA_CAMERA: "CHANGE_PANORAMA_CAMERA",
  CLOSE_PANO_VIEWER: "CLOSE_PANO_VIEWER",
  CLICK_END_SESSION: "CLICK_END_SESSION",
  SHOW_INTRO_SLIDE: "SHOW_INTRO_SLIDE",
  CHANGE_INTRO_SLIDE: "CHANGE_INTRO_SLIDE",
  EXPLORE_SHOW_FILTER: "EXPLORE_SHOW_FILTER",
  SHOW_GALLERY_TEAM: "SHOW_GALLERY_TEAM",
  CLOSE_GALLERY_TEAM: "CLOSE_GALLERY_TEAM",
  CLICK_NEXT_GALLERY_SECONDARY: "CLICK_NEXT_GALLERY_SECONDARY",
  CLICK_PREV_GALLERY_SECONDARY: "CLICK_PREV_GALLERY_SECONDARY",
  SHOW_GALLERY_EXPERIENCE: "SHOW_GALLERY_EXPERIENCE",
  CLOSE_GALLERY_EXPERIENCE: "CLOSE_GALLERY_EXPERIENCE",
  SHOW_GALLERY_VISION: "SHOW_GALLERY_VISION",
  CLOSE_GALLERY_VISION: "CLOSE_GALLERY_VISION",
  SHOW_GALLERY_LOCATION: "SHOW_GALLERY_LOCATION",
  CLOSE_GALLERY_LOCATION: "CLOSE_GALLERY_LOCATION",
  CLICK_SUBTAB_GALLERY_LANDING_PAGE: "CLICK_SUBTAB_GALLERY_LANDING_PAGE",
  PLAY_FILM_GALLERY_PAGE: "PLAY_FILM_GALLERY_PAGE",
  STOP_FILM_GALLERY_PAGE: "STOP_FILM_GALLERY_PAGE",
  SHOW_MEDIA_GALLERY_PAGE: "SHOW_MEDIA_GALLERY_PAGE",
  CLOSE_MEDIA_GALLERY_PAGE: "CLOSE_MEDIA_GALLERY_PAGE",
  SHOW_GALLERY_AMENITIES: "SHOW_GALLERY_AMENITIES",
  CLOSE_GALLERY_AMENITIES: "CLOSE_GALLERY_AMENITIES",
  CLICK_NEXT_GALLERY_PRIMARY: "CLICK_NEXT_GALLERY_PRIMARY",
  CLICK_PREV_GALLERY_PRIMARY: "CLICK_PREV_GALLERY_PRIMARY",
  CLICK_FLOOR_VIEW_PAGE: "CLICK_FLOOR_VIEW_PAGE",
  SHOW_PLAN_VIEW_PAGE: "SHOW_PLAN_VIEW_PAGE",
  HIDE_PLAN_VIEW_PAGE: "HIDE_PLAN_VIEW_PAGE",
  SELECT_MEDIA_VIEW_PAGE: "SELECT_MEDIA_VIEW_PAGE",
  RESET_FILTER: "RESET_FILTER",
  HIDE_FILTER: "HIDE_FILTER",
  SHOW_FILTER: "SHOW_FILTER",
  SELECT_AVAILABILITY_FILTER: "SELECT_AVAILABILITY_FILTER",
  SELECT_BEDROOM_FILTER: "SELECT_BEDROOM_FILTER",
  CHANGE_LOT_SIZE_FILTER: "CHANGE_LOT_SIZE_FILTER",
  CLICK_SEE_VIEWS_UNIT: "CLICK_SEE_VIEWS_UNIT",
  CLICK_VIEW_FLOORPLAN_UNIT: "CLICK_VIEW_FLOORPLAN_UNIT",
  CLOSE_FLOORPLAN_UNIT: "CLOSE_FLOORPLAN_UNIT",
  CLICK_VIEW_GALLERY_UNIT: "CLICK_VIEW_GALLERY_UNIT",
  CLICK_VIEW_VIRTUAL_TOUR_UNIT: "CLICK_VIEW_VIRTUAL_TOUR_UNIT",
  CLOSE_GALLERY_UNIT: "CLOSE_GALLERY_UNIT",
  CLOSE_FLOORPLAN_UNIT_DETAIL: "CLOSE_FLOORPLAN_UNIT_DETAIL",
  CLOSE_GALLERY_UNIT_DETAIL: "CLOSE_GALLERY_UNIT_DETAIL",
  REOPEN_FILTER_FLOORPLAN_UNIT_DETAIL: "REOPEN_FILTER_FLOORPLAN_UNIT_DETAIL",
  REOPEN_FILTER_GALLERY_UNIT_DETAIL: "REOPEN_FILTER_GALLERY_UNIT_DETAIL",
  GO_TO_SLIDE_GALLERY_UNIT_DETAIL: "GO_TO_SLIDE_GALLERY_UNIT_DETAIL",
  CLICK_LOGO: "CLICK_LOGO",
  CLICK_START_SESSION: "CLICK_START_SESSION",
  CLOSE_CENTER_MODAL_RIGHT_PANEL: "CLOSE_CENTER_MODAL_RIGHT_PANEL",
  CLOSE_AMENITIES_MODAL: "CLOSE_AMENITIES_MODAL",
  NAVIGATE_AMENITY_GALLERY: "NAVIGATE_AMENITY_GALLERY",
  CHANGE_MIN_MULTI_RANGE_SLIDER: "CHANGE_MIN_MULTI_RANGE_SLIDER",
  CHANGE_MAX_MULTI_RANGE_SLIDER: "CHANGE_MAX_MULTI_RANGE_SLIDER",
  SET_ACTIVE_OBJECT_IDS: "SET_ACTIVE_OBJECT_IDS",
  TOAST_MESSAGE: "TOAST_MESSAGE",
  CLICK_LOGOUT: "CLICK_LOGOUT",
  PAGE_SCROLL: "PAGE_SCROLL",
  SELECT_USER_SESSION: "SELECT_USER_SESSION",
  END_POST_SESSION: "END_POST_SESSION",
  SWITCH_HOTSPOT: "SWITCH_HOTSPOT",
};

export const HOTSPOT_TEXT = {
  EXPLORE_AVAILABILITY: "explore_availability",
  EXPLORE_BUILDING: "explore_building",
  EXPLORE_CITY: "explore_city",
};
